import api from "./controllersApi";

// دالة لاستدعاء Site_FeatchCompatiblePart_Paged
export const fetchCompatibleParts = (params = {}) => {
  // params يمكن أن يحتوي على:
  // brand, group, type, YearFrom, YearTo, freeText, productNo, cat, subCat, subSubCat,
  // isStock, modelCode, carProductNo, PageNumber, PageSize, SortBy, SortDir
  return api.get("/api/Parts/search", { params });
};
